const Containers = {
  baseStyle: {},
  variants: {},
}

export default Containers
